import {
  ON_START_UPDATE_PROSPEKT_DEADLINE,ON_UPDATE_PROSPEKT_DEADLINE,ON_ERROR_UPDATE_PROSPEKT_DEADLINE,
  ON_START_CHANGE_PROSPEKT_KUND,ON_CHANGE_PROSPEKT_KUND,ON_ERROR_CHANGE_PROSPEKT_KUND,
  ON_START_ADD_AVTAL_SHARED_KUNDER, ON_ADD_AVTAL_SHARED_KUNDER, ON_ERROR_ADD_AVTAL_SHARED_KUNDER,
  ON_START_GET_AVTAL_SHARED_KUNDER, ON_GET_AVTAL_SHARED_KUNDER, ON_ERROR_GET_AVTAL_SHARED_KUNDER,
  ON_START_DELETE_AVTAL_SHARED_KUNDER,ON_DELETE_AVTAL_SHARED_KUNDER,ON_ERROR_DELETE_AVTAL_SHARED_KUNDER,
  ON_START_GET_PROSPEKTLIST_USER,ON_GET_PROSPEKTLIST_USER,ON_ERROR_GET_PROSPEKTLIST_USER,
  ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,ON_ERROR_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,
  ON_GET_CHANGE_PROSPEKT_VY,ON_GET_CHANGE_PROSPEKT_VY_SORT,ON_START_GET_UPDATED_AVTAL_KALKYL,ON_GET_UPDATED_AVTAL_KALKYL,ON_ERROR_GET_UPDATED_AVTAL_KALKYL,
  ON_GET_SETTING_INITIAL_AVTAL,
  ON_START_GET_AVTAL_OTASKS, ON_GET_AVTAL_OTASKS, ON_ERROR_GET_AVTAL_OTASKS,
  ON_START_GET_AVTAL_FREEINPUTS,ON_GET_AVTAL_FREEINPUTS,ON_ERROR_GET_AVTAL_FREEINPUTS,
  ON_START_GET_AVTAL_OFFERTL_ID,ON_GET_AVTAL_OFFERTL_ID,ON_ERROR_GET_AVTAL_OFFERTL_ID,
  ON_START_GET_AVTAL_FAKTUROR,ON_GET_AVTAL_FAKTUROR,ON_ERROR_GET_AVTAL_FAKTUROR,
  ON_START_FORTNOX_NEWKUND_AVTAL, ON_FORTNOX_NEWKUND_AVTAL, ON_ERROR_FORTNOX_NEWKUND_AVTAL,
  ON_START_AVTAL_IMPORT_KD_EXCEL, ON_AVTAL_IMPORT_KD_EXCEL, ON_ERROR_AVTAL_IMPORT_KD_EXCEL,
  ON_START_AVTAL_KUNDDATA_TEMPORARY, ON_AVTAL_KUNDDATA_TEMPORARY, ON_ERROR_AVTAL_KUNDDATA_TEMPORARY,
  ON_START_FETCH_EXCEL_KUNDDATA_AVTAL,ON_FETCH_EXCEL_KUNDDATA_AVTAL,ON_ERROR_EXCEL_KUNDDATA_AVTAL,

    ON_SAVE_AVTAL_CALC_ITEMS,
    ON_START_SAVE_AVTAL_CALC_ITEMS,
    ON_ERROR_SAVE_AVTAL_CALC_ITEMS,
    ON_START_NEW_AVTAL,SET_AVTALVY_TYPE,UNSET_AVTALVY_TYPE,
    ON_NEW_EVENT_AVTAL,ON_START_NEW_EVENT_AVTAL,ON_ERROR_NEW_EVENT_AVTAL,
    ON_NEW_AVTAL,ON_GET_ANTAL_AKTIVITETER_AVTAL,ON_CLOSE_AVTAL_TOASTR,
    ON_ERROR_NEW_AVTAL,
    ON_START_GET_AVTAL_ORGNR,
    ON_GET_AVTAL_ORGNR,
    ON_ERROR_GET_AVTAL_ORGNR,
    ON_START_GET_AVTAL_ID,ON_GET_AVTAL_ID,ON_ERROR_GET_AVTAL_ID,
    ON_START_GET_AVTAL_REST_ID,ON_GET_AVTAL_REST_ID,ON_ERROR_GET_AVTAL_REST_ID,
    ON_START_EDIT_AVTAL,
    ON_EDIT_AVTAL,
    ON_ERROR_EDIT_AVTAL,
    ON_START_NEW_AVTAL_HANDELSE,
    ON_NEW_AVTAL_HANDELSE,
    ON_ERROR_NEW_AVTAL_HANDELSE,
    ON_START_GET_AVTAL_HISTORY_ID,
    ON_GET_AVTAL_HISTORY_ID,
    ON_ERROR_GET_AVTAL_HISTORY_ID,    
    ON_START_NEW_AVTAL_KALKYL_ID,
    ON_NEW_AVTAL_KALKYL_ID,
    ON_ERROR_NEW_AVTAL_KALKYL_ID,
    ON_START_NEW_AVTAL_ABOKALKYL_ID,
    ON_NEW_AVTAL_ABOKALKYL_ID,
    ON_ERROR_NEW_AVTAL_ABOKALKYL_ID, 
    ON_START_GET_AVTAL_KALKYL_ID,
    ON_GET_AVTAL_KALKYL_ID,
    ON_ERROR_GET_AVTAL_KALKYL_ID,
    ON_START_UPDATE_AVTAL_KALKYL_RAD,
    ON_UPDATE_AVTAL_KALKYL_RAD,
    ON_ERROR_UPDATE_AVTAL_KALKYL_RAD  ,
    ON_START_DELETE_AVTAL_KALKYL_RAD,
    ON_DELETE_AVTAL_KALKYL_RAD,
    ON_ERROR_DELETE_AVTAL_KALKYL_RAD,
    ON_GET_AVTAL_USER,ON_GET_AVTALF_USER,
    ON_START_GET_AVTAL_USER,
    ON_ERROR_GET_AVTAL_USER,
    ON_ERROR_NEW_PROSPEKT,
    ON_NEW_PROSPEKT,
    ON_START_NEW_PROSPEKT,
    ON_START_GET_PROSPEKT_ORGNR,
    ON_GET_PROSPEKT_ORGNR,
    ON_ERROR_GET_PROSPEKT_ORGNR,
    ON_START_DELETE_PROSPEKT,
    ON_DELETE_PROSPEKT,
    ON_ERROR_DELETE_PROSPEKT,
    ON_START_DELETE_AVTAL,
    ON_DELETE_AVTAL,
    ON_ERROR_DELETE_AVTAL,
    ON_GET_AVTAL_USER_HEADER,    ON_START_GET_AVTAL_USER_HEADER,    ON_ERROR_GET_AVTAL_USER_HEADER,
    ON_START_GET_BILLING_AVTAL_USER_HEADER,ON_GET_BILLING_AVTAL_USER_HEADER,ON_ERROR_GET_BILLING_AVTAL_USER_HEADER,
    ON_START_GET_PROSPEKT_USER_HEADER,
    ON_GET_PROSPEKT_USER_HEADER,
    ON_ERROR_GET_PROSPEKT_USER_HEADER,
    ON_START_GET_PROSPEKT_USER,
    ON_START_GET_PROSPEKT_USER_START,
    ON_GET_PROSPEKT_USER,
    ON_START_GET_PROSPEKT_USER_NEW,ON_GET_PROSPEKT_USER_NEW,
    ON_ERROR_GET_PROSPEKT_USER,
    ON_UPDATE_PROSPEKT_FAS,
    ON_ERROR_UPDATE_PROSPEKT_FAS,
    ON_START_UPDATE_PROSPEKT_FAS,
    ON_AVTAL_NEW_DOC,
    ON_START_AVTAL_NEW_DOC,
    ON_ERROR_AVTAL_NEW_DOC,
    ON_START_GET_AVTAL_DOC_ID,
    ON_GET_AVTAL_DOC_ID,
    ON_ERROR_GET_AVTAL_DOC_ID,
    ON_DELETE_AVTAL_DOC_RAD,    ON_ERROR_DELETE_AVTAL_DOC_RAD,    ON_START_DELETE_AVTAL_DOC_RAD,
    ON_START_UPDATE_AVTAL_DOC_RAD,ON_UPDATE_AVTAL_DOC_RAD,ON_ERROR_UPDATE_AVTAL_DOC_RAD,
    ON_GET_AVTPRO_BY_ORGNR,
    ON_START_GET_AVTPRO_BY_ORGNR,
    ON_ERROR_GET_AVTPRO_BY_ORGNR,
    ON_GET_AVTAL_ORDER_ID,
    ON_ERROR_GET_AVTAL_ORDER_ID,
    ON_START_GET_AVTAL_ORDER_ID,
    ON_START_DELETE_AVTAL_ORDER_RAD,
    ON_DELETE_AVTAL_ORDER_RAD,
    ON_ERROR_DELETE_AVTAL_ORDER_RAD,
    ON_START_GET_AVTAL_KUNDDATA_ID,
    ON_GET_AVTAL_KUNDDATA_ID,
    ON_ERROR_GET_AVTAL_KUNDDATA_ID,
    ON_START_AVTAL_ANTAL_UPDATE,
    ON_NEW_AVTAL_ANTAL_UPDATE,
    ON_ERROR_AVTAL_ANTAL_UPDATE,
    ON_START_AVTAL_KUNDDATA_INSERT,
    ON_NEW_AVTAL_KUNDDATA_INSERT,
    ON_ERROR_AVTAL_KUNDDATA_INSERT,
    ON_START_AVTAL_KUNDDATA_COPYTA,
    ON_AVTAL_KUNDDATA_COPYTA,
    ON_ERROR_AVTAL_KUNDDATA_COPYTA,
    ON_START_DELETE_AVTAL_KUNDDATA_RAD,
    ON_DELETE_AVTAL_KUNDDATA_RAD,
    ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD,
    ON_START_GET_PROSPEKT_FASPAGE_USER,
    ON_GET_PROSPEKT_FASPAGE_USER,
    ON_ERROR_GET_PROSPEKT_FASPAGE_USER,
    ON_START_BUFFER_PROSPEKT_FAS,
    ON_ERROR_BUFFER_PROSPEKT_FAS,
    ON_BUFFER_PROSPEKT_FAS,
    ON_BUFFER_PROSPEKT_FAS_BUFFERED,
    ON_OPEN_FILTER_AVTAL,ON_ClOSE_FILTER_AVTAL,
    ON_OPEN_FILTER_PROSPEKT,ON_ClOSE_FILTER_PROSPEKT,
    ON_START_DELETE_AVTALLIST,ON_DELETE_AVTALLIST,ON_ERROR_DELETE_AVTALLIST,
    ON_START_CHANGE_START_BILLING_AVTALLIST,ON_CHANGE_START_BILLING_AVTALLIST,ON_ERROR_CHANGE_START_BILLING_AVTALLIST,
    ON_START_CHANGE_CLOSE_BILLING_AVTALLIST,ON_CHANGE_CLOSE_BILLING_AVTALLIST,ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST,
    ON_START_CHANGE_SKAPA_BILLING_AVTALLIST,ON_CHANGE_SKAPA_BILLING_AVTALLIST,ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST,
    ON_START_CHANGE_DATE_AVTALLIST,ON_CHANGE_DATE_AVTALLIST,ON_ERROR_CHANGE_DATE_AVTALLIST,
    ON_START_CHANGE_ANSVARIG_AVTALLIST,ON_CHANGE_ANSVARIG_AVTALLIST,ON_ERROR_CHANGE_ANSVARIG_AVTALLIST,
    ON_START_DELETE_AVTAL_HANDELSE,ON_DELETE_AVTAL_HANDELSE,ON_ERROR_DELETE_AVTAL_HANDELSE,
    ON_START_UPDATER_AVTAL_HANDELSE,ON_UPDATER_AVTAL_HANDELSE,ON_ERROR_UPDATER_AVTAL_HANDELSE,
    ON_START_PROSPEKT_FORLORAD, ON_PROSPEKT_FORLORAD, ON_ERROR_PROSPEKT_FORLORAD,
    ON_START_PROSPEKT_TILLBAKA, ON_PROSPEKT_TILLBAKA, ON_ERROR_PROSPEKT_TILLBAKA,
    ON_START_AVTAL_TILLBAKA, ON_AVTAL_TILLBAKA, ON_ERROR_AVTAL_TILLBAKA,
    ON_START_OMFORHANDLA_AVTAL,ON_OMFORHANDLA_AVTAL,ON_ERROR_OMFORHANDLA_AVTAL,
    ON_START_GET_FORSALJING_ORGNR,  ON_GET_FORSALJING_ORGNR,  ON_ERROR_GET_FORSALJING_ORGNR,
    ON_START_AVTAL_BILLING_START, ON_AVTAL_BILLING_START, ON_ERROR_AVTAL_BILLING_START,
    ON_START_AVTAL_BILLING_CLOSE, ON_AVTAL_BILLING_CLOSE, ON_ERROR_AVTAL_BILLING_CLOSE,
    ON_START_AVTAL_BILLING_UPDATE, ON_AVTAL_BILLING_UPDATE, ON_ERROR_AVTAL_BILLING_UPDATE,
    SET_ZERO_AVTAL,SET_PROSPEKT_FILTER,SET_AVTAL_FILTER, ON_GET_AVTAL_PAGE_BASIC,
    SET_ZERO_PROSPEKT,
    ON_START_SNABB_VUNNEN,ON_SNABB_VUNNEN,ON_ERROR_SNABB_VUNNEN,
    ON_GET_ALL_HANDELSE_AVTAL,
    ON_START_GET_ALL_HANDELSE_AVTAL,
    ON_ERROR_GET_ALL_HANDELSE_AVTAL,
    ON_SET_CURRENT_AVTAL_ANTAL_FRIA,
    ON_SET_CURRENT_AVTAL_TAGGAR
} from "../constants/ActionTypes";
import jwtDecode from 'jwt-decode';
import {isUndefined,isEmpty} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
    AvtalList:[],
    AvtalListHeader:{},
    ProspektList:[],
    ForsaljningList:[],
    ProspektListByUser:[],
    ProspektListByUserNew:0,
    AvtalListByUser:[],
    currentAvtal:{},
    ProspektTableList:[],
		ProspektTableListLoading: false,
    AntalProspektTableList:0,
    currentAvtalHistory:[],
    currentAvtalKalkyl:[],
    currentAvtalDocs:[],
    currentAvtalOrder:[],
    AvtalOffertl:[],
    ListOfAVPro:[],
    AvtalFreeInputs:[],
    FakturorListAv:[],
    Avtalmessage:"",
    isAVLoading:false,
    isPRLoading:false,
    TotalAvtal:[{total:0}],
    TotalSumma:{},
    TotalMonth:{},
    TotalProspekt:[{total:0}],
    TotalSummaProspekt:{Month:{varde:0,Budget:10},Quarter:{varde:0,Budget:10},Year:{varde:0,Budget:10}},
    UpdatedProspektListByUser:[],
    isLoadingKD:false,
    currentAvtalKundData:[],
    IsFromKdAvtal:0,
    AvtalPage:1,
    AvtalPagerows:isUndefined(localStorage.token)?25:jwtDecode(localStorage.token).user_AvtalPageRow,
    PagerowsFakturering:isUndefined(localStorage.token)?25:jwtDecode(localStorage.token).user_FavtalPageRow,
    AvtalFortnoxFak:[],
    FilterProspektPopUp:false,
    FilterAvtalPopUp:false,
    BillingHeader:{Total:0,Varde:0,Varde1:{Abonnemange:0,Summa:0}},
    ProspektFilterOption:isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter), 
    AvtalFilterOption:isUndefined(localStorage.AvtalFilter)?[]:JSON.parse(localStorage.AvtalFilter), 
    ProspektSortObj:isUndefined(localStorage.ProspektSortObj)?{column: 'Gtill', Type: 1}:JSON.parse(localStorage.ProspektSortObj),
    currentAvtalVYIndex:isUndefined(localStorage.currentAvtalVYIndex)?0:JSON.parse(localStorage.currentAvtalVYIndex), 
    ResponseAvtalMsg:{},
    bufferProspektReady: false,
    bufferingProspekt: false,
    buffferProspektArray: [],
    buffferToColumnId: 0,
    OavtalTasks:[],
    prospektVyn:isUndefined(localStorage.prospektVyn)?0:JSON.parse(parseInt(localStorage.prospektVyn)),

}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case SET_ZERO_AVTAL:{
        return INIT_STATE;
      }
      case SET_ZERO_PROSPEKT:{
        return INIT_STATE;
      }
      case SET_AVTALVY_TYPE:{
        localStorage.setItem("currentAvtalVYIndex", JSON.stringify(action.payload));
        return { ...state,
          currentAvtalVYIndex: action.payload,
        };
      }
      case ON_GET_AVTAL_PAGE_BASIC:{
        return {
          ...state,
          AvtalPage:action.payload.Page
        }
      }
      case ON_SET_CURRENT_AVTAL_TAGGAR:{
        return {
          ...state,
          currentAvtal: {
            ...state.currentAvtal,
            Taggar: action.payload
          }
        }
      }

      case UNSET_AVTALVY_TYPE:{
        localStorage.removeItem("currentAvtalVYIndex");
        return { ...state,
          currentAvtalVYIndex: 0,
        };
      }
      case SET_PROSPEKT_FILTER: {
        console.log("SET_PROSPEKT_FILTER",action.payload)
        localStorage.removeItem("ProspektFilter");
        localStorage.setItem("ProspektFilter", JSON.stringify(action.payload));
        return { ...state,
          ProspektFilterOption: action.payload,
        };
      }
      case SET_AVTAL_FILTER: {
        console.log("SET_AVTAL_FILTER",action.payload)
        localStorage.removeItem("AvtalFilter");
        localStorage.setItem("AvtalFilter", JSON.stringify(action.payload));
        return { ...state,
          AvtalFilterOption: action.payload
        };
      }
    case ON_START_GET_AVTAL_ID:{
      console.log("ON_START_GET_AVTAL_ID",action)
      return {
        ...state,
        ResponseAvtalMsg:{},
        currentAvtal:{},
        currentAvtalKalkyl:{},
      }
    }
    case ON_GET_AVTAL_ID:{
      console.log("ON_GET_AVTAL_ID",action)
      return {
        ...state,
        Avtalmessage:"",
        currentAvtal:action.payload.Avtal
      }
    }
    case ON_ERROR_GET_AVTAL_ID:{
      console.log("ON_ERROR_GET_AVTAL_ID",action)
      return {
        ...state,
        //Avtalmessage:"Error",
        currentAvtal:{}
      }
    }
    //ON_START_GET_AVTAL_REST_ID,ON_GET_AVTAL_REST_ID
    case ON_START_GET_AVTAL_REST_ID:{
      console.log("ON_START_GET_AVTAL_REST_ID",action)
      return {
        ...state,
      }
    }
    case ON_ERROR_GET_AVTAL_REST_ID:{
      console.log("ON_ERROR_GET_AVTAL_REST_ID",action)
      return {
        ...state,
      }
    }
    case ON_GET_AVTAL_REST_ID:{
      console.log("ON_GET_AVTAL_REST_ID",action)
      return {
        ...state,
        Avtalmessage:"",
        currentAvtal:action.payload.Avtal
      }
    }
    //
    case ON_GET_ALL_HANDELSE_AVTAL: {
      return {
        ...state,
        currentAvtal:{
          ...state.currentAvtal,
          handelser: action.payload.handelser
        }
      }
    }
    case ON_START_GET_ALL_HANDELSE_AVTAL: {
      return {
        ...state,
      }
    }
    case ON_ERROR_GET_ALL_HANDELSE_AVTAL: {
      return {
        ...state,
        Avtalmessage:"Error",
      }
    }
    case ON_START_NEW_AVTAL:{
        console.log("ON_START_NEW_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"",
          currentAvtal:{},
          currentAvtalKalkyl:{},
          AvtalList:[],
          isAVLoading:false,
          AvtalListByUser:[],
        }
      }
    case ON_SET_CURRENT_AVTAL_ANTAL_FRIA: {
      console.log("ON_SET_CURRENT_AVTAL_ANTAL_FRIA", action)
      return {
        ...state,
        currentAvtal: {
          ...state.currentAvtal,
          antalFria: action.payload.antalFria
        }
      }
    }
    case ON_ERROR_NEW_AVTAL:{
        console.log("ON_ERROR_NEW_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"Error",
          currentAvtal:{},
          isAVLoading:false
        }
      }
    case ON_NEW_AVTAL:{
        console.log("ON_NEW_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"Skapad",
          currentAvtal:action.payload.Avtal,
          isAVLoading:false
        }
      }
    case ON_START_NEW_PROSPEKT:{
        console.log("ON_START_NEW_PROSPEKT",action)
        return {
          ...state,
          Avtalmessage:"",
          currentAvtal:{},
          currentAvtalKalkyl:{},
          AvtalList:[],
        //  ProspektListByUser:[],
          isAVLoading:false
        }
      }
    case ON_ERROR_NEW_PROSPEKT:{
        console.log("ON_ERROR_NEW_PROSPEKT",action)
        return {
          ...state,
          Avtalmessage:"Error",
          currentAvtal:{},
          isAVLoading:false
        }
      }
    case ON_NEW_PROSPEKT:{
        console.log("ON_NEW_PROSPEKT",action)
        return {
          ...state,
          Avtalmessage:"Skapad",
          currentAvtal:action.payload.Avtal,
          isAVLoading:false,
        }
      }
    case ON_START_GET_AVTAL_ORGNR:{
        console.log("ON_START_GET_AVTAL_ORGNR",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          AvtalList:[],
          TotalAvtal:[{total:0}],
          currentAvtal:{}
        }
      }
    case ON_ERROR_GET_AVTAL_ORGNR:{
        console.log("ON_ERROR_GET_AVTAL_ORGNR",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false,
          currentAvtal:{}
        }
      }
    case ON_GET_AVTAL_ORGNR:{
        console.log("ON_GET_AVTAL_ORGNR",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          AvtalList:action.payload.Avtals,
          TotalAvtal:action.payload.Antal,
          currentAvtal:{},
          currentAvtalKalkyl:{},
        }
      }
    
    case ON_START_GET_AVTAL_USER:{
        console.log("ON_START_GET_AVTAL_USER",action)
        return {
          ...state,
          isAVLoading:false,
          Avtalmessage:"",
          currentAvtal:{},
          currentAvtalKalkyl:{},
          ResponseAvtalMsg:{msg:translate("Action.fetching.list"),type:"info",loading:true},
        }
      }
    case ON_ERROR_GET_AVTAL_USER:{
        console.log("ON_ERROR_GET_AVTAL_USER",action)
        return {
          ...state,
          isAVLoading:false,
          ResponseAvtalMsg:{msg:action.payload,type:"error",loading:false},
          Avtalmessage:""
        }
      }
    case ON_GET_AVTALF_USER:{
        console.log("ON_GET_AVTALF_USER",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          AvtalListByUser:action.payload.Avtals,
          TotalAvtal:action.payload.TotalAvtal,
          PagerowsFakturering:action.payload.Pagerows,
          ResponseAvtalMsg:{},
          currentAvtalKalkyl:{},
        }
      }
   case ON_GET_SETTING_INITIAL_AVTAL:{
      console.log("ON_GET_SETTING_INITIAL_AVTAL",action)
      return {
        ...state,
        PagerowsFakturering:action.payload.user_FavtalPageRow,
        AvtalPagerows:action.payload.user_AvtalPageRow,
      }
    } /**/
    case ON_GET_AVTAL_USER:{
        console.log("ON_GET_AVTAL_USER",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          AvtalListByUser:action.payload.Avtals,
          TotalAvtal:action.payload.TotalAvtal,
          AvtalPagerows:action.payload.Pagerows,
          ResponseAvtalMsg:{},
          currentAvtalKalkyl:{},
        }
      }
    case ON_START_GET_PROSPEKT_USER:{
        console.log("ON_START_GET_PROSPEKT_USER",action)
        return {
          ...state,
          Avtalmessage:"",
          currentAvtal:{}
        }
      }
    case ON_START_GET_PROSPEKT_USER_START:{
        console.log("ON_START_GET_PROSPEKT_USER_START",action)
        return {
          ...state,
          Avtalmessage:"",         
          currentAvtal:{},
          currentAvtalKalkyl:{},
         // ProspektListByUser:[],
          isPRLoading:true,
        }
      }
      /*   
      case ON_START_GET_PROSPEKT_USER_START_SEARCH:{
        console.log("ON_START_GET_PROSPEKT_USER_START",action)
        return {
          ...state,
          Avtalmessage:"",         
          currentAvtal:{},
          ProspektListByUser:[],
          isPRLoading:true,
        }
      }
      */
    case ON_ERROR_GET_PROSPEKT_USER:{
        console.log("ON_ERROR_GET_PROSPEKT_USER",action)
        return {
          ...state,
          isPRLoading:false,
          Avtalmessage:"Error"
        }
      }

    //ON_START_GET_PROSPEKT_USER_NEW,ON_GET_PROSPEKT_USER_NEW,
    case ON_START_GET_PROSPEKT_USER_NEW:{
      console.log("ON_START_GET_PROSPEKT_USER_NEW",action)
      return {
        ...state,
      }
    }
    case ON_GET_PROSPEKT_USER_NEW:{
      console.log("ON_GET_PROSPEKT_USER_NEW",action)
      return {
        ...state,
        ProspektListByUser:action.payload.Prospekts,
      }
    }
    // 
    case ON_GET_PROSPEKT_USER:{
        console.log("ON_GET_PROSPEKT_USER",action)
        return {
          ...state,
          Avtalmessage:"",
          isPRLoading:false,
          ProspektListByUser:action.payload.Prospekts,
        }
      }
    case ON_START_EDIT_AVTAL:{
        console.log("ON_START_EDIT_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_EDIT_AVTAL:{
        console.log("ON_ERROR_EDIT_AVTAL",action)
        return {
          ...state,
          isAVLoading:false
        }
      }
    case ON_EDIT_AVTAL:{
        console.log("ON_EDIT_AVTAL",action)
        return {
          ...state,
          isAVLoading:false,
          currentAvtal:action.payload.Avtal,
        }
      }
    //, , ,
    case ON_START_AVTAL_TILLBAKA:{
      console.log("ON_START_AVTAL_TILLBAKA",action)
      return {
        ...state,
        Avtalmessage:"",
        isAVLoading:false
      }
    }
    case ON_AVTAL_TILLBAKA:{
      console.log("ON_AVTAL_TILLBAKA",action)
      return {
        ...state,
        isAVLoading:false,
        Avtalmessage:"Sparad",
        currentAvtal:action.payload.Avtal,
      }
    }
    case ON_ERROR_AVTAL_TILLBAKA:{
      console.log("ON_ERROR_AVTAL_TILLBAKA",action)
      return {
        ...state,
        Avtalmessage:"Error",
        isAVLoading:false
      }
    }
    //
    case ON_START_PROSPEKT_TILLBAKA:{
      console.log("ON_START_PROSPEKT_TILLBAKA",action)
      return {
        ...state,
        Avtalmessage:"",
        isAVLoading:false
      }
    }
    case ON_PROSPEKT_TILLBAKA:{
      console.log("ON_PROSPEKT_TILLBAKA",action)
      return {
        ...state,
        isAVLoading:false,
        Avtalmessage:"Sparad",
        currentAvtal:action.payload.Avtal,
      }
    }
    case ON_ERROR_PROSPEKT_TILLBAKA:{
      console.log("ON_ERROR_PROSPEKT_TILLBAKA",action)
      return {
        ...state,
        Avtalmessage:"Error",
        isAVLoading:false
      }
    }
    
    case ON_START_PROSPEKT_FORLORAD:{
      console.log("ON_START_PROSPEKT_FORLORAD",action)
      return {
        ...state,
        Avtalmessage:"",
        isAVLoading:false
      }
    }
    case ON_PROSPEKT_FORLORAD:{
      console.log("ON_PROSPEKT_FORLORAD",action)
      return {
        ...state,
        isAVLoading:false,
        Avtalmessage:"Sparad",
        currentAvtal:action.payload.Avtal,
      }
    }
    case ON_ERROR_PROSPEKT_FORLORAD:{
      console.log("ON_ERROR_PROSPEKT_FORLORAD",action)
      return {
        ...state,
        Avtalmessage:"Error",
        isAVLoading:false
      }
    }
//,,ON_ERROR_OMFORHANDLA_AVTAL,
case ON_START_OMFORHANDLA_AVTAL:{
  console.log("ON_START_OMFORHANDLA_AVTAL",action)
  return {
    ...state,
    Avtalmessage:"",
    isAVLoading:false
  }
}
case ON_OMFORHANDLA_AVTAL:{
  console.log("ON_OMFORHANDLA_AVTAL",action)
  return {
    ...state,
    isAVLoading:false,
    Avtalmessage:"Omförhandlad",
    currentAvtal:action.payload.Avtal,
  }
}
case ON_ERROR_OMFORHANDLA_AVTAL:{
  console.log("ON_ERROR_OMFORHANDLA_AVTAL",action)
  return {
    ...state,
    Avtalmessage:"Error",
    isAVLoading:false
  }
}
//
    case ON_START_NEW_AVTAL_HANDELSE:{
        console.log("ON_START_NEW_AVTAL_HANDELSE",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_NEW_AVTAL_HANDELSE:{
        console.log("ON_ERROR_NEW_AVTAL_HANDELSE",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_NEW_AVTAL_HANDELSE:{
        console.log("ON_NEW_AVTAL_HANDELSE",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          isAVLoading:false,
          currentAvtal:action.payload.Avtal,
        }
      }
    case ON_START_GET_AVTAL_HISTORY_ID:{
        console.log("ON_START_GET_AVTAL_HISTORY_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_GET_AVTAL_HISTORY_ID:{
        console.log("ON_ERROR_GET_AVTAL_HISTORY_ID",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_GET_AVTAL_HISTORY_ID:{
        console.log("ON_GET_AVTAL_HISTORY_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          currentAvtalHistory:action.payload.History,
        }
      }
    case ON_START_GET_AVTAL_KALKYL_ID:{
        console.log("ON_START_GET_AVTAL_KALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          currentAvtalKalkyl:{},
          isAVLoading:false
        }
      }
    case ON_ERROR_GET_AVTAL_KALKYL_ID:{
        console.log("ON_ERROR_GET_AVTAL_KALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_GET_AVTAL_KALKYL_ID:{
        console.log("ON_GET_AVTAL_KALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          currentAvtalKalkyl:action.payload.Kalkyl,
        }
      }
    case ON_START_UPDATE_AVTAL_KALKYL_RAD:{
        console.log("ON_START_UPDATE_AVTAL_KALKYL_RAD",action)
        return {
          ...state,
          Avtalmessage:"",
          currentAvtalKalkyl:{},
          isAVLoading:false
        }
      }
    case ON_ERROR_UPDATE_AVTAL_KALKYL_RAD:{
        console.log("ON_ERROR_UPDATE_AVTAL_KALKYL_RAD",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_UPDATE_AVTAL_KALKYL_RAD:{
        console.log("ON_UPDATE_AVTAL_KALKYL_RAD",action)
        return {
          ...state,
          Avtalmessage:"Spara",
          currentAvtalKalkyl:action.payload.Kalkyl,
          currentAvtal:action.payload.Avtal,
          isAVLoading:false
        }
      }
    case ON_START_DELETE_AVTAL_KALKYL_RAD:{
        console.log("ON_START_DELETE_AVTAL_KALKYL_RAD",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_DELETE_AVTAL_KALKYL_RAD:{
        console.log("ON_ERROR_DELETE_AVTAL_KALKYL_RAD",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_DELETE_AVTAL_KALKYL_RAD:{
        console.log("ON_DELETE_AVTAL_KALKYL_RAD",action)
        return {
          ...state,
          Avtalmessage:"Raderad",
          currentAvtalKalkyl:action.payload.results.Kalkyl,
          currentAvtal:action.payload.results.Avtal,
          isAVLoading:false
        }
      }
    case ON_START_NEW_AVTAL_KALKYL_ID:{
        console.log("ON_START_NEW_AVTAL_KALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_NEW_AVTAL_KALKYL_ID:{
        console.log("ON_ERROR_NEW_AVTAL_KALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_NEW_AVTAL_KALKYL_ID:{
        console.log("ON_NEW_AVTAL_KALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          isAVLoading:false,
          currentAvtal:action.payload.Avtal,
          currentAvtalKalkyl:action.payload.Kalkyl,
        }
      }

    case ON_SAVE_AVTAL_CALC_ITEMS: {
      return {
        ...state,
        Avtalmessage:"Sparad",
        isAVLoading:false,
        currentAvtal:{
          ...state.currentAvtal,
          Kalkyl: action.payload.AvtalKalkyl
        },
        currentAvtalKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_START_SAVE_AVTAL_CALC_ITEMS: {
      return {
        ...state,
        Avtalmessage:"",
        isAVLoading:false
      }
    }
    case ON_ERROR_SAVE_AVTAL_CALC_ITEMS: {
      return {
        ...state,
        Avtalmessage:"Error",
        isAVLoading:false
      }
    }
    case ON_START_NEW_AVTAL_ABOKALKYL_ID:{
        console.log("ON_START_NEW_AVTAL_ABOKALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_NEW_AVTAL_ABOKALKYL_ID:{
        console.log("ON_ERROR_NEW_AVTAL_ABOKALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_NEW_AVTAL_ABOKALKYL_ID:{
        console.log("ON_NEW_AVTAL_ABOKALKYL_ID",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          isAVLoading:false,
          currentAvtal:action.payload.Avtal,
          currentAvtalKalkyl:action.payload.Kalkyl,
        }
      }
    case ON_START_GET_PROSPEKT_ORGNR:{
        console.log("ON_START_GET_PROSPEKT_ORGNR",action)
        return {
          ...state,
          Avtalmessage:"",
          TotalProspekt:[{total:0}],
          ProspektList:[],
          currentAvtal:{},
          currentAvtalKalkyl:{},
        }
      }
    case ON_ERROR_GET_PROSPEKT_ORGNR:{
        console.log("ON_ERROR_GET_PROSPEKT_ORGNR",action)
        return {
          ...state,
          Avtalmessage:"Error",
          currentAvtal:{}
        }
      }
    case ON_GET_PROSPEKT_ORGNR:{
        console.log("ON_GET_PROSPEKT_ORGNR",action)
        return {
          ...state,
          Avtalmessage:"",
          ProspektList:action.payload.Prospekts,
          TotalProspekt:action.payload.Antal,
          currentAvtal:{},
          currentAvtalKalkyl:{},
        }
      }
    case ON_START_DELETE_PROSPEKT:{
        console.log("ON_START_DELETE_AVTAL",action)
        return {
          ...state,
          isPRLoading:true,
          Avtalmessage:"",
          ProspektList:[],
        }
      }
    case ON_ERROR_DELETE_PROSPEKT:{
        console.log("ON_ERROR_DELETE_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isPRLoading:false,
        }
      }
    case ON_DELETE_PROSPEKT:{
        console.log("ON_DELETE_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"",
          isPRLoading:false,
          ProspektList:action.payload.Prospekts,
          currentAvtal:{}
        }
      }
    case ON_START_DELETE_AVTAL:{
        console.log("ON_START_DELETE_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          AvtalList:[],
          currentAvtal:{},
          currentAvtalKalkyl:{},
        }
      }
    case ON_ERROR_DELETE_AVTAL:{
        console.log("ON_ERROR_DELETE_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false,
          currentAvtal:{}
        }
      }
    case ON_DELETE_AVTAL:{
        console.log("ON_DELETE_AVTAL",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          AvtalList:action.payload.Avtals,
          TotalAvtal:action.payload.Antal,
          currentAvtal:{}
        }
      }
    case ON_START_GET_AVTAL_USER_HEADER:{
        console.log("ON_START_GET_AVTAL_USER_HEADER",action)
        return {
          ...state,
          Avtalmessage:""
        }
      }
    case ON_ERROR_GET_AVTAL_USER_HEADER:{
        console.log("ON_ERROR_GET_AVTAL_USER_HEADER",action)
        return {
          ...state,
          Avtalmessage:"Error"
        }
      }
    case ON_GET_AVTAL_USER_HEADER:{
        console.log("ON_GET_AVTAL_USER_HEADER",action)
        return {
          ...state,
          Avtalmessage:"",
          TotalAvtal:action.payload.TotalAvtal,
          TotalMonth:action.payload.TotalMonth,
          TotalSumma:action.payload.TotalSumma,
        }
      }
    //ON_START_GET_BILLING_AVTAL_USER_HEADER,ON_GET_BILLING_AVTAL_USER_HEADER,ON_ERROR_GET_BILLING_AVTAL_USER_HEADER,
    case ON_START_GET_BILLING_AVTAL_USER_HEADER:{
      console.log("ON_START_GET_BILLING_AVTAL_USER_HEADER",action)
      return {
        ...state,
        BillingHeader:{Total:0,Varde:0,Varde1:{Abonnemange:0,Summa:0}},
      }
    }
  case ON_ERROR_GET_BILLING_AVTAL_USER_HEADER:{
      console.log("ON_ERROR_GET_BILLING_AVTAL_USER_HEADER",action)
      return {
        ...state,
        BillingHeader:{Total:0,Varde:0,Varde1:{Abonnemange:0,Summa:0}},
      }
    }
  case ON_GET_BILLING_AVTAL_USER_HEADER:{
      console.log("ON_GET_BILLING_AVTAL_USER_HEADER",action)
      return {
        ...state,
        BillingHeader:action.payload.BillingHeader,
      }
    }
    //
    case ON_START_GET_PROSPEKT_USER_HEADER:{
        console.log("ON_START_GET_PROSPEKT_USER_HEADER",action)
        return {
          ...state,
          Avtalmessage:""
        }
      }
    case ON_ERROR_GET_PROSPEKT_USER_HEADER:{
        console.log("ON_ERROR_GET_PROSPEKT_USER_HEADER",action)
        return {
          ...state,
          Avtalmessage:"Error"
        }
      }
    case ON_GET_PROSPEKT_USER_HEADER:{
        console.log("ON_GET_PROSPEKT_USER_HEADER",action)
        return {
          ...state,
          Avtalmessage:"",
          TotalProspekt:action.payload.TotalProspekt,
          TotalSummaProspekt:action.payload.TotalSumma
        }
      }
      
    case ON_START_UPDATE_PROSPEKT_FAS:{
        console.log("ON_START_UPDATE_PROSPEKT_FAS",action)
        return {
          ...state,
          Avtalmessage:"",
          ProspektList:[]
        }
      }
    case ON_ERROR_UPDATE_PROSPEKT_FAS:{
        console.log("ON_ERROR_UPDATE_PROSPEKT_FAS",action)
        return {
          ...state,
          Avtalmessage:"Error",
          ProspektList:[]
        }
      }
    case ON_UPDATE_PROSPEKT_FAS:{
        console.log("ON_UPDATE_PROSPEKT_FAS",action)
        let NewData=[];
        
        if(action.payload.Prospekts.length>0){
         NewData = state.ProspektListByUser.map((n)=>{
            if(n.Order === action.payload.Prospekts[0].Order){
              return action.payload.Prospekts[0]
              }
            else if(n.Order === action.payload.Prospekts[1].Order){
              return action.payload.Prospekts[1]
            }
            else{
              return n
            }
          })
        }
        return {
          ...state,
          Avtalmessage:"Updated",
          ProspektListByUser:NewData
        }
      }
      case ON_START_AVTAL_NEW_DOC:{
        console.log("ON_START_AVTAL_NEW_DOC",action)
        return {
          ...state,
          isAVLoading:false,
          Avtalmessage:""
        }
      }
      case ON_AVTAL_NEW_DOC:{
        console.log("ON_AVTAL_NEW_DOC",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          isAVLoading:false,
          currentAvtal:action.payload.Avtal,
          currentAvtalDocs:action.payload.Docs,
        }
      }
      case ON_ERROR_AVTAL_NEW_DOC:{
        console.log("ON_ERROR_AVTAL_NEW_DOC",action)
        return {
          ...state,
          isAVLoading:false,
          Avtalmessage:"Error"
        }
      }
      case ON_START_GET_AVTAL_DOC_ID:{
        console.log("ON_START_GET_AVTAL_DOC_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_GET_AVTAL_DOC_ID:{
        console.log("ON_ERROR_GET_AVTAL_DOC_ID",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_GET_AVTAL_DOC_ID:{
        console.log("ON_GET_AVTAL_DOC_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false,
          currentAvtalDocs:action.payload.Docs,
        }
      }
      case ON_START_GET_AVTAL_ORDER_ID:{
        console.log("ON_START_GET_AVTAL_ORDER_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_GET_AVTAL_ORDER_ID:{
        console.log("ON_ERROR_GET_AVTAL_ORDER_ID",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_GET_AVTAL_ORDER_ID:{
        console.log("ON_GET_AVTAL_ORDER_ID",action)
        return {
          ...state,
          isAVLoading:false,
          Avtalmessage:"",
          currentAvtalOrder:action.payload.Orders,
        }
      }
      case ON_START_DELETE_AVTAL_ORDER_RAD:{
        console.log("ON_START_DELETE_AVTAL_ORDER_RAD",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
    case ON_ERROR_DELETE_AVTAL_ORDER_RAD:{
        console.log("ON_ERROR_DELETE_AVTAL_ORDER_RAD",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    case ON_DELETE_AVTAL_ORDER_RAD:{
        console.log("ON_DELETE_AVTAL_ORDER_RAD",action)
        return {
          ...state,
          isAVLoading:false,
          Avtalmessage:"Raderad",
          currentAvtalOrder:action.payload.Orders,
          currentAvtal:action.payload.Avtal,
        }
      }
      //ON_START_UPDATE_AVTAL_DOC_RAD,ON_UPDATE_AVTAL_DOC_RAD,ON_ERROR_UPDATE_AVTAL_DOC_RAD,
      case ON_START_UPDATE_AVTAL_DOC_RAD:{
        console.log("ON_START_UPDATE_AVTAL_DOC_RAD",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
      
    case ON_ERROR_UPDATE_AVTAL_DOC_RAD:{
        console.log("ON_ERROR_UPDATE_AVTAL_DOC_RAD",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    
    case ON_UPDATE_AVTAL_DOC_RAD:{
        console.log("ON_UPDATE_AVTAL_DOC_RAD",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          currentAvtalDocs:action.payload.Docs,
          //currentAvtal:action.payload.Avtal,
          isAVLoading:false
        }
      }  
      //
      case ON_START_DELETE_AVTAL_DOC_RAD:{
        console.log("ON_START_DELETE_AVTAL_DOC_RAD",action)
        return {
          ...state,
          Avtalmessage:"",
          isAVLoading:false
        }
      }
      
    case ON_ERROR_DELETE_AVTAL_DOC_RAD:{
        console.log("ON_ERROR_DELETE_AVTAL_DOC_RAD",action)
        return {
          ...state,
          Avtalmessage:"Error",
          isAVLoading:false
        }
      }
    
    case ON_DELETE_AVTAL_DOC_RAD:{
        console.log("ON_DELETE_AVTAL_DOC_RAD",action)
        return {
          ...state,
          Avtalmessage:"Raderad",
          currentAvtalDocs:action.payload.Docs,
          currentAvtal:action.payload.Avtal,
          isAVLoading:false
        }
      }  
      case ON_START_GET_AVTPRO_BY_ORGNR:{
        console.log("ON_START_GET_AVTPRO_BY_ORGNR",action)
        return {
          ...state,
          ListOfAVPro:[]
        }
      }
    case ON_ERROR_GET_AVTPRO_BY_ORGNR:{
        console.log("ON_ERROR_GET_AVTPRO_BY_ORGNR",action)
        return {
          ...state,
          Avtalmessage:"Error",
          ListOfAVPro:[]
        }
      }
    case ON_GET_AVTPRO_BY_ORGNR:{
        console.log("ON_GET_AVTPRO_BY_ORGNR",action)
        return {
          ...state,
          ListOfAVPro:action.payload.ListOfAVPro,
        }
      }  
    case ON_START_GET_AVTAL_KUNDDATA_ID:{
        console.log("ON_START_GET_AVTAL_KUNDDATA_ID",action)
        return {
          ...state,
          Avtalmessage:"",
          isLoadingKD:true,
          currentAvtalKundData:[]
        }
      }
    case ON_GET_AVTAL_KUNDDATA_ID:{
        console.log("ON_GET_AVTAL_KUNDDATA_ID",action)
        return {
          ...state,
          isLoadingKD:false,
          Avtalmessage:"",
          IsFromKdAvtal:isUndefined(action.payload.isFromKunData)?0:action.payload.isFromKunData,
          currentAvtalKundData:action.payload.KundData
        }
      }
    case ON_ERROR_GET_AVTAL_KUNDDATA_ID:{
        console.log("ON_ERROR_GET_AVTAL_KUNDDATA_ID",action)
        return {
          ...state,
          isLoadingKD:false,
          Avtalmessage:"Error"
        }
      }
      case ON_START_AVTAL_ANTAL_UPDATE:{
        console.log("ON_START_AVTAL_ANTAL_UPDATE",action)
        return {
          ...state,
          Avtalmessage:"",
          isLoadingKD:true,
          currentAvtalKundData:[]
        }
      }
    case ON_NEW_AVTAL_ANTAL_UPDATE:{
        console.log("ON_NEW_AVTAL_ANTAL_UPDATE",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          IsFromKdAvtal:1,
          currentAvtalKundData:action.payload.KundData,
          currentAvtal:action.payload.Avtal,
          isLoadingKD:false,
        }
      }
    case ON_ERROR_AVTAL_ANTAL_UPDATE:{
        console.log("ON_ERROR_AVTAL_ANTAL_UPDATE",action)
        return {
          ...state,
          isLoadingKD:false,
          Avtalmessage:"Error"
        }
      }
      case ON_START_AVTAL_KUNDDATA_INSERT:{
        console.log("ON_START_AVTAL_KUNDDATA_INSERT",action)
        return {
          ...state,
          isLoadingKD:true,
          Avtalmessage:"",
          currentAvtalKundData:[]
        }
      }
    case ON_NEW_AVTAL_KUNDDATA_INSERT:{
        console.log("ON_NEW_AVTAL_KUNDDATA_INSERT",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          isLoadingKD:false,
          currentAvtalKundData:action.payload.KundData,
          currentAvtal:action.payload.Avtal
        }
      }
    case ON_ERROR_AVTAL_KUNDDATA_INSERT:{
        console.log("ON_ERROR_AVTAL_KUNDDATA_INSERT",action)
        return {
          ...state,
          isLoadingKD:false,
          Avtalmessage:"Error"
        }
      }
      case ON_START_AVTAL_KUNDDATA_COPYTA:{
        console.log("ON_START_AVTAL_KUNDDATA_COPYTA",action)
        return {
          ...state,
          isLoadingKD:true,
          Avtalmessage:"",
          currentAvtalKundData:[]
        }
      }
    case ON_AVTAL_KUNDDATA_COPYTA:{
        console.log("ON_AVTAL_KUNDDATA_COPYTA",action)
        return {
          ...state,
          Avtalmessage:"Sparad",
          isLoadingKD:false,
          currentAvtalKundData:action.payload.KundData
        }
      }
    case ON_ERROR_AVTAL_KUNDDATA_COPYTA:{
        console.log("ON_ERROR_AVTAL_KUNDDATA_COPYTA",action)
        return {
          ...state,
          isLoadingKD:false,
          Avtalmessage:"Error"
        }
      }
      case ON_START_DELETE_AVTAL_KUNDDATA_RAD:{
        console.log("ON_START_DELETE_AVTAL_KUNDDATA_RAD",action)
        return {
          ...state,
          isLoadingKD:true,
          Avtalmessage:"",
          currentAvtalKundData:[],
        }
      }
    case ON_DELETE_AVTAL_KUNDDATA_RAD:{
        console.log("ON_DELETE_AVTAL_KUNDDATA_RAD",action)
        return {
          ...state,
          isLoadingKD:false,
          IsFromKdAvtal:1,
          Avtalmessage:"Raderad",
          currentAvtalKundData:action.payload.KundData,
          currentAvtal:action.payload.Avtal
        }
      }
    case ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD:{
        console.log("ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD",action)
        return {
          ...state,
          isLoadingKD:false,
          Avtalmessage:"Error"
        }
      }
      
    case ON_START_GET_PROSPEKT_FASPAGE_USER:{
        console.log("ON_START_GET_PROSPEKT_FASPAGE_USER",action)
        return {
          ...state,
          ProspektListByUserNew:[]
        }
      }
    case ON_GET_PROSPEKT_FASPAGE_USER:{
        console.log("ON_GET_PROSPEKT_FASPAGE_USER",action)

        let NewData=[];
        if(action.payload.ProspektListFas.length > 0){
         NewData = state.ProspektListByUser.filter((n)=>{
            if(n.Order === parseInt(action.payload.Fas)){
              return n
              }
          })
        
        let NewDatas = {
          ...NewData[0],
          List:NewData[0].List.concat(isUndefined(action.payload.ProspektListFas)?[]:action.payload.ProspektListFas)
        }
       
        let NewDatad=[];
        NewDatad = state.ProspektListByUser.map((n)=>{
            if(n.Order === parseInt(action.payload.Fas)){
              return NewDatas
              }
            else{
              return n
            }
          })
          /**/
          return {
            ...state,
            ProspektListByUser:NewDatad
          }
        } else{
          return {...state}
        }
        }
        
    case ON_ERROR_GET_PROSPEKT_FASPAGE_USER:{
        console.log("ON_ERROR_GET_PROSPEKT_FASPAGE_USER",action)
        return {
          ...state,
          ProspektListByUserNew:[],
          isLoadingKD:false,
          Avtalmessage:"Error"
        }
      }
      case ON_OPEN_FILTER_AVTAL:{
        console.log("ON_OPEN_FILTER_AVTAL",action)
        return {
          ...state,
          FilterAvtalPopUp:true,
          AvtalFilterOption:isUndefined(localStorage.AvtalFilter)?[]:JSON.parse(localStorage.AvtalFilter)
        }
      }
      case ON_ClOSE_FILTER_AVTAL:{
        console.log("ON_ClOSE_FILTER_AVTAL",action)
        return {
          ...state,
          FilterAvtalPopUp:false
        }
      }
      case ON_OPEN_FILTER_PROSPEKT:{
        console.log("ON_OPEN_FILTER_PROSPEKT",action)
        return {
          ...state,
          FilterProspektPopUp:true,
          ProspektFilterOption:isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
        }
      }
      case ON_ClOSE_FILTER_PROSPEKT:{
        console.log("ON_ClOSE_FILTER_PROSPEKT",action)
        return {
          ...state,
          FilterProspektPopUp:false
        }
      }
    //,  ,  ON_ERROR_GET_FORSALJING_ORGNR,
    case ON_START_GET_FORSALJING_ORGNR:{
      console.log("ON_START_GET_FORSALJING_ORGNR",action)
      return {
        ...state,
        TotalProspekt:[{total:0}],
      }
    }
    case ON_GET_FORSALJING_ORGNR:{
      console.log("ON_GET_FORSALJING_ORGNR",action)
      return {
        ...state,
        ForsaljningList:action.payload.Prospekts,
        TotalProspekt:action.payload.Antal,
      }
    }
    case ON_ERROR_GET_FORSALJING_ORGNR:{
      console.log("ON_ERROR_GET_FORSALJING_ORGNR",action)
      return {
        ...state
      }
    }
    //ON_START_DELETE_AVTAL_HANDELSE,ON_DELETE_AVTAL_HANDELSE,ON_ERROR_DELETE_AVTAL_HANDELSE,
    case ON_START_DELETE_AVTAL_HANDELSE:{
      console.log("ON_START_DELETE_AVTAL_HANDELSE",action)
      return {
          ...state,
        //  RapportFile:[] 
      }
  }
  case ON_DELETE_AVTAL_HANDELSE:{
      console.log("ON_DELETE_AVTAL_HANDELSE",action)
      return {
          ...state,
          Avtalmessage:"Raderad",
          currentAvtal:action.payload.Avtal,
      }
  }
  case ON_ERROR_DELETE_AVTAL_HANDELSE:{
      console.log("ON_ERROR_DELETE_AVTAL_HANDELSE",action)
      return {
          ...state,
          Avtalmessage:"Error"
      }
  }
    //ON_START_UPDATER_AVTAL_HANDELSE,ON_UPDATER_AVTAL_HANDELSE,ON_ERROR_UPDATER_AVTAL_HANDELSE,
    case ON_START_UPDATER_AVTAL_HANDELSE:{
      console.log("ON_START_DELETE_AVTAL_HANDELSE",action)
      return {
          ...state,
        //  RapportFile:[] 
      }
  }
  case ON_UPDATER_AVTAL_HANDELSE:{
      console.log("ON_UPDATER_AVTAL_HANDELSE",action)
      return {
          ...state,
          Avtalmessage:"Raderad",
          currentAvtal:action.payload.Avtal,
      }
  }
  case ON_ERROR_UPDATER_AVTAL_HANDELSE:{
      console.log("ON_ERROR_UPDATER_AVTAL_HANDELSE",action)
      return {
          ...state,
          Avtalmessage:"Error"
      }
  }
    //
    case ON_START_GET_AVTAL_OFFERTL_ID:{
      console.log("ON_START_GET_AVTAL_OFFERTL_ID",action)
      return {
          ...state,
          AvtalOffertl:[] 
      }
  }
  case ON_GET_AVTAL_OFFERTL_ID:{
      console.log("ON_GET_AVTAL_OFFERTL_ID",action)
      return {
          ...state,
          AvtalOffertl:action.payload.AvtalOffertl,
      }
  }
  case ON_ERROR_GET_AVTAL_OFFERTL_ID:{
      console.log("ON_ERROR_GET_AVTAL_OFFERTL_ID",action)
      return {
          ...state,
          Avtalmessage:"Error"
      }
  }
    //
  //,,
  case ON_ERROR_DELETE_AVTALLIST:{
    console.log("ON_ERROR_DELETE_AVTALLIST",action)
    return {
      ...state,
      isAVLoading:false,
      ResponseAvtalMsg:{msg:translate("Error.Delete.Contracts"),type:"error",loading:false},
      Avtalmessage:""
    }
  }
case ON_DELETE_AVTALLIST:{
    console.log("ON_DELETE_AVTALLIST",action)
    return {
      ...state,
      Avtalmessage:"",
      ResponseAvtalMsg:{msg:action.payload.message,type:"warning",loading:false},
      isAVLoading:false,
      AvtalListByUser:action.payload.Avtals,
      TotalAvtal:action.payload.TotalAvtal,
      currentAvtal:{}
    }
  }
case ON_START_DELETE_AVTALLIST:{
    console.log("ON_START_DELETE_AVTALLIST",action)
    return {
      ...state,
      ResponseAvtalMsg:{},
      Avtalmessage:"",
      isAVLoading:false,
    }
  }
  //,,,
  case ON_ERROR_CHANGE_ANSVARIG_AVTALLIST:{
    console.log("ON_ERROR_CHANGE_ANSVARIG_AVTALLIST",action)
    return {
      ...state,
      isAVLoading:false,
      ResponseAvtalMsg:{msg:translate("Error.Update.Resbonsible.Contracts"),type:"error",loading:false},
      Avtalmessage:""
    }
  }
case ON_CHANGE_ANSVARIG_AVTALLIST:{
    console.log("ON_CHANGE_ANSVARIG_AVTALLIST",action)
    return {
      ...state,
      Avtalmessage:"",
      ResponseAvtalMsg:{msg:action.payload.message,type:"success",loading:false},
      isAVLoading:false,
      AvtalListByUser:action.payload.Avtals,
      TotalAvtal:action.payload.TotalAvtal,
      currentAvtal:{}
    }
  }
case ON_START_CHANGE_ANSVARIG_AVTALLIST:{
    console.log("ON_START_CHANGE_ANSVARIG_AVTALLIST",action)
    return {
      ...state,
      Avtalmessage:"",
      ResponseAvtalMsg:{},
      isAVLoading:false,
    }
  }
  //,,,
  case ON_ERROR_CHANGE_START_BILLING_AVTALLIST:{
    console.log("ON_ERROR_CHANGE_START_BILLING_AVTALLIST",action)
    return {
      ...state,
      isAVLoading:false,
      ResponseAvtalMsg:{msg:translate("Error.Update.Billing.Contracts"),type:"error",loading:false},
      Avtalmessage:""
    }
  }
case ON_CHANGE_START_BILLING_AVTALLIST:{
    console.log("ON_CHANGE_START_BILLING_AVTALLIST",action)
    return {
      ...state,
      Avtalmessage:"",
      ResponseAvtalMsg:{msg:action.payload.message,type:"success",loading:false},
      isAVLoading:false,
      AvtalListByUser:action.payload.Avtals,
      TotalAvtal:action.payload.TotalAvtal,
      currentAvtal:{}
    }
  }
case ON_START_CHANGE_START_BILLING_AVTALLIST:{
    console.log("ON_START_CHANGE_START_BILLING_AVTALLIST",action)
    return {
      ...state,
      Avtalmessage:"",
      ResponseAvtalMsg:{},
      isAVLoading:false,
    }
  }
  //  
  case ON_ERROR_CHANGE_DATE_AVTALLIST:{
    console.log("ON_ERROR_CHANGE_DATE_AVTALLIST",action)
    return {
      ...state,
      isAVLoading:false,
      ResponseAvtalMsg:{msg:translate("Error.Update.Date.Contracts"),type:"error",loading:false},
      Avtalmessage:""
    }
  }
case ON_CHANGE_DATE_AVTALLIST:{
    console.log("ON_CHANGE_DATE_AVTALLIST",action)
    return {
      ...state,
      Avtalmessage:"",
      ResponseAvtalMsg:{msg:action.payload.message,type:"success",loading:false},
      isAVLoading:false,
      AvtalListByUser:action.payload.Avtals,
      TotalAvtal:action.payload.TotalAvtal,
      currentAvtal:{}
    }
  }
case ON_START_CHANGE_DATE_AVTALLIST:{
    console.log("ON_START_CHANGE_DATE_AVTALLIST",action)
    return {
      ...state,
      ResponseAvtalMsg:{},
      Avtalmessage:"",
      isAVLoading:false,
    }
  }
  //ON_START_CHANGE_PROSPEKT_KUND,ON_CHANGE_PROSPEKT_KUND,ON_ERROR_CHANGE_PROSPEKT_KUND,
  case ON_START_CHANGE_PROSPEKT_KUND:{
    console.log("ON_START_CHANGE_PROSPEKT_KUND",action)
    return {
      ...state,
      ResponseAvtalMsg:{msg:translate("Action.changeing.Customer.prospect"),type:"info",loading:true}
    }
  }
  case ON_CHANGE_PROSPEKT_KUND:{
    console.log("ON_START_CHANGE_PROSPEKT_KUND",action)
    return {
      ...state,
      ResponseAvtalMsg:{msg:translate("Action.Save.prospect"),type:"success",loading:false},
      currentAvtal:{}
    }
  }
  case ON_ERROR_CHANGE_PROSPEKT_KUND:{
    console.log("ON_ERROR_CHANGE_PROSPEKT_KUND",action)
    return {
      ...state,
      ResponseAvtalMsg:{msg:translate("Error.change.Customer.prospect"),type:"error",loading:false}
    }
  }
  //
  //ON_START_FORTNOX_NEWKUND_AVTAL, ON_FORTNOX_NEWKUND_AVTAL, ON_ERROR_FORTNOX_NEWKUND_AVTAL,
  case ON_START_FORTNOX_NEWKUND_AVTAL:{
    console.log("ON_START_FORTNOX_NEWKUND_AVTAL",action)
    return {
        ...state,
      //  RapportFile:[] 
    }
}
case ON_FORTNOX_NEWKUND_AVTAL:{
    console.log("ON_FORTNOX_NEWKUND_AVTAL",action)
    return {
        ...state,
        Avtalmessage:"Kopplad",
        currentAvtal:action.payload.Avtal,
    }
}
case ON_ERROR_FORTNOX_NEWKUND_AVTAL:{
    console.log("ON_ERROR_FORTNOX_NEWKUND_AVTAL",action)
    return {
        ...state,
        Avtalmessage:action.payload,
    }
}
  //ON_START_AVTAL_IMPORT_KD_EXCEL, ON_AVTAL_IMPORT_KD_EXCEL, ON_ERROR_AVTAL_IMPORT_KD_EXCEL,
  case ON_START_AVTAL_IMPORT_KD_EXCEL:{
    console.log("ON_START_AVTAL_IMPORT_KD_EXCEL",action)
    return {
        ...state,
        Avtalmessage:"",
        isLoadingKD:true,
        currentAvtalKundData:[]
    }
}
case ON_AVTAL_IMPORT_KD_EXCEL:{
    console.log("ON_AVTAL_IMPORT_KD_EXCEL",action)
    return {
        ...state,
        Avtalmessage:"Klar",
        isLoadingKD:false,
        currentAvtalKundData:action.payload.KundData
    }
}
case ON_ERROR_AVTAL_IMPORT_KD_EXCEL:{
    console.log("ON_ERROR_AVTAL_IMPORT_KD_EXCEL",action)
    return {
      ...state,
        isLoadingKD:false,
        OrderMessage:"Error"
    }
}
  //ON_START_AVTAL_KUNDDATA_TEMPORARY, ON_AVTAL_KUNDDATA_TEMPORARY, ON_ERROR_AVTAL_KUNDDATA_TEMPORARY,
  case ON_START_AVTAL_KUNDDATA_TEMPORARY:{
    console.log("ON_START_AVTAL_KUNDDATA_TEMPORARY",action)
    return {
        ...state,
    }
  }
  case ON_AVTAL_KUNDDATA_TEMPORARY:{
    console.log("ON_AVTAL_KUNDDATA_TEMPORARY",action)
    return {
        ...state,
    }
  }
  case ON_ERROR_AVTAL_KUNDDATA_TEMPORARY:{
    console.log("ON_ERROR_AVTAL_KUNDDATA_TEMPORARY",action)
    return {
        ...state,
    }
  }
  //
  case ON_START_AVTAL_BILLING_START:{
    console.log("ON_START_AVTAL_BILLING_START",action)
    return {
      ...state,
      Avtalmessage:"",
      isAVLoading:false
    }
  }
  case ON_AVTAL_BILLING_START:{
    console.log("ON_AVTAL_BILLING_START",action)
    let currnetAvtal1 ={
      ...state.currentAvtal,
        Avtal:[{
          ...state.currentAvtal.Avtal[0],
          startBilling:1
        }],
        Billing:action.payload.Billing
    }
    console.log(currnetAvtal1)
    return {
      ...state,
      isAVLoading:false,
      Avtalmessage:"Starta Abonnemang",
      currentAvtal:currnetAvtal1
    }
  }
  case ON_ERROR_AVTAL_BILLING_START:{
    console.log("ON_ERROR_AVTAL_BILLING_START",action)
    return {
      ...state,
      Avtalmessage:"Error",
      isAVLoading:false
    }
  }
  //
  case ON_START_AVTAL_BILLING_CLOSE:{
    console.log("ON_START_AVTAL_BILLING_CLOSE",action)
    return {
      ...state,
      Avtalmessage:"",
      isAVLoading:false
    }
  }
  case ON_AVTAL_BILLING_CLOSE:{
    console.log("ON_AVTAL_BILLING_CLOSE",action)
    let currnetAvtal1 ={
      ...state.currentAvtal,
        Avtal:[{
          ...state.currentAvtal.Avtal[0],
          startBilling:0
        }],
        Billing:action.payload.Billing
    }
    console.log(currnetAvtal1)
    return {
      ...state,
      isAVLoading:false,
      Avtalmessage:"Stäng Abonnemang",
      currentAvtal:currnetAvtal1
    }
  }
  case ON_ERROR_AVTAL_BILLING_CLOSE:{
    console.log("ON_ERROR_AVTAL_BILLING_CLOSE",action)
    return {
      ...state,
      Avtalmessage:"Error",
      isAVLoading:false
    }
  }
 //ON_START_AVTAL_BILLING_UPDATE, ON_AVTAL_BILLING_UPDATE, ON_ERROR_AVTAL_BILLING_UPDATE,
 case ON_START_AVTAL_BILLING_UPDATE:{
  console.log("ON_START_AVTAL_BILLING_UPDATE",action)
  return {
    ...state,
    Avtalmessage:"",
    isAVLoading:false
  }
}
 case ON_AVTAL_BILLING_UPDATE:{
  console.log("ON_AVTAL_BILLING_UPDATE",action)
  return {
    ...state,
    isAVLoading:false,
    Avtalmessage:"Sparads",
    currentAvtal:{
      ...state.currentAvtal,
      Billing:action.payload.Billing
    }
    ,
  }
}
 case ON_ERROR_AVTAL_BILLING_UPDATE:{
  console.log("ON_ERROR_AVTAL_BILLING_UPDATE",action)
  return {
    ...state,
    isAVLoading:false,
    Avtalmessage:"Error"
  }
}
//ON_START_CHANGE_SKAPA_BILLING_AVTALLIST,ON_CHANGE_SKAPA_BILLING_AVTALLIST,ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST,
case ON_START_CHANGE_SKAPA_BILLING_AVTALLIST:{
  console.log("ON_START_CHANGE_SKAPA_BILLING_AVTALLIST",action)
  return {
    ...state,
    ResponseAvtalMsg:{msg: translate("Action.Creating.invoice"),type:"info",loading:true},
    Avtalmessage:"",
    isAVLoading:false
  }
}
 case ON_CHANGE_SKAPA_BILLING_AVTALLIST:{
  console.log("ON_CHANGE_SKAPA_BILLING_AVTALLIST",action)
  return {
    ...state,    
    AvtalListByUser:action.payload.Avtals,
    TotalAvtal:action.payload.TotalAvtal,
    currentAvtal:{},
    isAVLoading:false,
    ResponseAvtalMsg:{msg:isUndefined(action.payload.ErrorM) ||isEmpty(action.payload.ErrorM)?action.payload.message:action.payload.ErrorM,type:isUndefined(action.payload.ErrorM) ||isEmpty(action.payload.ErrorM)?"success":"error",loading:false},
    Avtalmessage:"", 
  }
}
 case ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST:{
  console.log("ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST",action)
  return {
    ...state,
    isAVLoading:false,
    ResponseAvtalMsg:{msg:translate("Error.start.invoicing"),type:"error",loading:false},
    Avtalmessage:""
  }
}
//ON_START_CHANGE_CLOSE_BILLING_AVTALLIST,ON_CHANGE_CLOSE_BILLING_AVTALLIST,ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST,
case ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST:{
  console.log("ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST",action)
  return {
    ...state,
    ResponseAvtalMsg:{msg:translate("Error.Close.invoicing"),type:"error",loading:false},
    isAVLoading:false,
    Avtalmessage:"Error"
  }
}
case ON_CHANGE_CLOSE_BILLING_AVTALLIST:{
  console.log("ON_CHANGE_CLOSE_BILLING_AVTALLIST",action)
  return {
    ...state,
    Avtalmessage:"",
    ResponseAvtalMsg:{msg:action.payload.message,type:"warning",loading:false},
    isAVLoading:false,
    AvtalListByUser:action.payload.Avtals,
    TotalAvtal:action.payload.TotalAvtal,
    currentAvtal:{}
  }
}
case ON_START_CHANGE_CLOSE_BILLING_AVTALLIST:{
  console.log("ON_START_CHANGE_CLOSE_BILLING_AVTALLIST",action)
  return {
    ...state,
    ResponseAvtalMsg:{},
    Avtalmessage:"",
    isAVLoading:false,
  }
}
//
case ON_GET_ANTAL_AKTIVITETER_AVTAL:{
  console.log("ON_GET_ANTAL_AKTIVITETER_AVTAL",action)
  return {
    ...state,
    currentAvtal:{
      ...state.currentAvtal,
      antalAktiviteter:[{antalAktiviteter:action.payload.Aktiveteter.length}]
    }
  }
}
//
case ON_START_FETCH_EXCEL_KUNDDATA_AVTAL:{
  console.log("ON_START_FETCH_EXCEL_KUNDDATA_AVTAL",action)
  return {
    ...state,
    Avtalmessage:"",
  }
}
case ON_FETCH_EXCEL_KUNDDATA_AVTAL:{
  console.log("ON_FETCH_EXCEL_KUNDDATA_AVTAL",action)
  return {
    ...state,
  }
}
case ON_ERROR_EXCEL_KUNDDATA_AVTAL:{
  console.log("ON_ERROR_EXCEL_KUNDDATA_AVTAL",action)
  return {
    ...state,
    Avtalmessage:"Error",
  }
}
//
case ON_START_NEW_EVENT_AVTAL:{
  return {
    ...state,
    isAVLoading:false
  }
}
//ON_NEW_EVENT_AVTAL
case ON_NEW_EVENT_AVTAL:{
  return {
    ...state,
    Avtalmessage:"Skapad",
    currentAvtal:action.payload.Avtal,
    isAVLoading:false
  }
}
//ON_ERROR_NEW_EVENT_AVTAL
case ON_ERROR_NEW_EVENT_AVTAL:{
  return {
    ...state,
    Avtalmessage:"Error",
    isAVLoading:false
  }
}
//ON_CLOSE_AVTAL_TOASTR
case ON_CLOSE_AVTAL_TOASTR:{
  return {
    ...state,
    ResponseAvtalMsg:{}
  }
}
//

    case ON_START_BUFFER_PROSPEKT_FAS: {
      console.log('ON_START_BUFFER_PROSPEKT_FAS', action.payload)
      return {
        ...state,
        bufferProspektReady: false,
        bufferingProspekt: true,
        buffferProspektArray: [],
        buffferToColumnId: 0,
      }
    }
    case ON_ERROR_BUFFER_PROSPEKT_FAS: {
      console.log('ON_ERROR_BUFFER_PROSPEKT_FAS', action.payload)
      return {
        ...state,
        bufferProspektReady: false,
        bufferingProspekt: false,
        buffferProspektArray: [],
        buffferToColumnId: 0,
      }
    }
    case ON_BUFFER_PROSPEKT_FAS: {
      console.log('ON_BUFFER_PROSPEKT_FAS', action.payload)

      return {
        ...state,
        bufferProspektReady: true,
        bufferingProspekt: false,
        buffferProspektArray: action.payload.ProspektListFas,
        buffferToColumnId: action.payload.ColumnId,
      }
    }

    case ON_BUFFER_PROSPEKT_FAS_BUFFERED: {
      return {
        ...state,
        bufferProspektReady: false,
        buffferProspektArray: [],
        buffferToColumnId: 0,
      }
    }
//ON_START_GET_AVTAL_FAKTUROR,ON_GET_AVTAL_FAKTUROR,ON_ERROR_GET_AVTAL_FAKTUROR,
case ON_START_GET_AVTAL_FAKTUROR:{
  console.log("ON_START_GET_AVTAL_FAKTUROR",action)
  return {
    ...state,
    Avtalmessage:"",
    FakturorListAv:[]
  }
}
case ON_ERROR_GET_AVTAL_FAKTUROR:{
  console.log("ON_ERROR_GET_AVTAL_FAKTUROR",action)
  return {
    ...state,
  }
}
case ON_GET_AVTAL_FAKTUROR:{
  console.log("ON_GET_AVTAL_FAKTUROR",action)
  return {
    ...state,
    Avtalmessage:"",
    FakturorListAv:action.payload.FakturorListAv
  }
}
//ON_START_SNABB_VUNNEN,ON_SNABB_VUNNEN,ON_ERROR_SNABB_VUNNEN,
case ON_START_SNABB_VUNNEN:{
  console.log("ON_START_SNABB_VUNNEN",action)
  return {
    ...state,
    Avtalmessage:""
  }
}
case ON_SNABB_VUNNEN:{
  console.log("ON_SNABB_VUNNEN",action)
  return {
    ...state,
    currentAvtal:action.payload.Avtal,
    Avtalmessage:"Vunnen"
  }
}
case ON_ERROR_SNABB_VUNNEN:{
  console.log("ON_ERROR_SNABB_VUNNEN",action)
  return {
    ...state,
    Avtalmessage:"Error"
  }
}
//FakturorListAv
//ON_START_GET_AVTAL_FREEINPUTS,ON_GET_AVTAL_FREEINPUTS,ON_ERROR_GET_AVTAL_FREEINPUTS,
case ON_START_GET_AVTAL_FREEINPUTS:{
  console.log("ON_START_GET_AVTAL_FREEINPUTS",action)
  return {
    ...state,
    AvtalFreeInputs:[],
    Avtalmessage:""
  }
}
case ON_GET_AVTAL_FREEINPUTS:{
  console.log("ON_GET_AVTAL_FREEINPUTS",action)
  return {
    ...state,
    AvtalFreeInputs:action.payload.AvtalFreeInputs,
  }
}
case ON_ERROR_GET_AVTAL_FREEINPUTS:{
  console.log("ON_ERROR_GET_AVTAL_FREEINPUTS",action)
  return {
    ...state,
    Avtalmessage:"Error"
  }
}
//ON_START_GET_AVTAL_OTASKS, ON_GET_AVTAL_OTASKS, ON_ERROR_GET_AVTAL_OTASKS,
case ON_START_GET_AVTAL_OTASKS:{
  console.log("ON_START_GET_AVTAL_OTASKS",action)
  return {
    ...state,
    OavtalTasks:[],
    Avtalmessage:""
  }
}
case ON_GET_AVTAL_OTASKS:{
  console.log("ON_GET_AVTAL_OTASKS",action)
  return {
    ...state,
    OavtalTasks:action.payload.OavtalTasks,
  }
}
case ON_ERROR_GET_AVTAL_OTASKS:{
  console.log("ON_ERROR_GET_AVTAL_OTASKS",action)
  return {
    ...state,
    Avtalmessage:"Error"
  }
}
//ON_START_GET_UPDATED_AVTAL_KALKYL,ON_GET_UPDATED_AVTAL_KALKYL,ON_ERROR_GET_UPDATED_AVTAL_KALKYL,
case ON_START_GET_UPDATED_AVTAL_KALKYL:{
  console.log("ON_START_GET_UPDATED_AVTAL_KALKYL",action)
  return {
    ...state,
  }
}
case ON_GET_UPDATED_AVTAL_KALKYL:{
  console.log("ON_GET_UPDATED_AVTAL_KALKYL",action)
  return {
    ...state,
    currentAvtal:{
      ...state.currentAvtal,
      Kalkyl:action.payload.results.Kalkyl
    }
  }
}
case ON_ERROR_GET_UPDATED_AVTAL_KALKYL:{
  console.log("ON_ERROR_GET_UPDATED_AVTAL_KALKYL",action)
  return {
    ...state,
  }
}
//ON_GET_CHANGE_PROSPEKT_VY
case ON_GET_CHANGE_PROSPEKT_VY:{
  console.log("ON_GET_CHANGE_PROSPEKT_VY",action)
  return {
    ...state,
    prospektVyn:action.payload.prospektVyn
  }
}
//ON_GET_CHANGE_PROSPEKT_VY_SORT
case ON_GET_CHANGE_PROSPEKT_VY_SORT:{
  console.log("ON_GET_CHANGE_PROSPEKT_VY_SORT",action)
  return {
    ...state,
    ProspektSortObj:action.payload.ProspektSortObj
  }
}
//ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,ON_ERROR_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,
case ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY:{
  console.log("ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY",action)
  return {
    ...state,
    ProspektKalkylSummary:[]
  }
}
case ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY:{
  console.log("ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY",action)
  return {
    ...state,
    ProspektKalkylSummary:action.payload.ProspektKalkylSummary
  }
}

case ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY:{
  console.log("ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY",action)
  return {
    ...state
  }
}
//ON_START_GET_PROSPEKTLIST_USER,ON_GET_PROSPEKTLIST_USER,ON_ERROR_GET_PROSPEKTLIST_USER
case ON_START_GET_PROSPEKTLIST_USER:{
  console.log("ON_START_GET_PROSPEKTLIST_USER",action)
  return {
    ...state,
		ProspektTableListLoading: true,
  }
}
case ON_GET_PROSPEKTLIST_USER:{
  console.log("ON_GET_PROSPEKTLIST_USER",action)
  return {
    ...state,
    isPRLoading:false,
    ProspektTableList:action.payload.ProspektTableList,
		ProspektTableListLoading: false,
    AntalProspektTableList:action.payload.AntalProspektTableList
  }
}

case ON_ERROR_GET_PROSPEKTLIST_USER:{
  console.log("ON_ERROR_GET_PROSPEKTLIST_USER",action)
  return {
    ...state,
		ProspektTableListLoading: false,
    ResponseAvtalMsg:{msg:translate("Error.fetch.prospekt"),type:"error",loading:false},
  }
}
//ON_START_GET_AVTAL_SHARED_KUNDER, ON_GET_AVTAL_SHARED_KUNDER, ON_ERROR_GET_AVTAL_SHARED_KUNDER,
case ON_START_GET_AVTAL_SHARED_KUNDER:{
  console.log("ON_START_GET_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
  }
}
case ON_GET_AVTAL_SHARED_KUNDER:{
  console.log("ON_GET_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
    currentAvtal:{
      ...state.currentAvtal,
      SharedOrgnr:action.payload.SharedOrgnr
    }
  }
}
case ON_ERROR_GET_AVTAL_SHARED_KUNDER:{
  console.log("ON_ERROR_GET_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
  }
}
//ON_START_DELETE_AVTAL_SHARED_KUNDER,ON_DELETE_AVTAL_SHARED_KUNDER,ON_ERROR_DELETE_AVTAL_SHARED_KUNDER,
case ON_START_DELETE_AVTAL_SHARED_KUNDER:{
  console.log("ON_START_DELETE_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
  }
}
case ON_DELETE_AVTAL_SHARED_KUNDER:{
  console.log("ON_DELETE_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
    currentAvtal:{
      ...state.currentAvtal,
      SharedOrgnr:action.payload.SharedOrgnr
    }
  }
}
case ON_ERROR_DELETE_AVTAL_SHARED_KUNDER:{
  console.log("ON_ERROR_DELETE_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
  }
}
//
case ON_START_ADD_AVTAL_SHARED_KUNDER:{
  console.log("ON_START_ADD_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
  }
}
case ON_ADD_AVTAL_SHARED_KUNDER:{
  console.log("ON_ADD_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
    currentAvtal:{
      ...state.currentAvtal,
      SharedOrgnr:action.payload.SharedOrgnr
    }
  }
}
case ON_ERROR_ADD_AVTAL_SHARED_KUNDER:{
  console.log("ON_ERROR_ADD_AVTAL_SHARED_KUNDER",action)
  return {
    ...state,
  }
}
//ON_START_UPDATE_PROSPEKT_DEADLINE,ON_UPDATE_PROSPEKT_DEADLINE,ON_ERROR_UPDATE_PROSPEKT_DEADLINE,
case ON_START_UPDATE_PROSPEKT_DEADLINE:{
  console.log("ON_START_UPDATE_PROSPEKT_DEADLINE",action)
  return {
    ...state,
  }
}
case ON_UPDATE_PROSPEKT_DEADLINE:{
  console.log("ON_UPDATE_PROSPEKT_DEADLINE",action)
  return {
    ...state,
    ResponseAvtalMsg:{msg:action.payload.message,type:"success",loading:false}
  }
}
case ON_ERROR_UPDATE_PROSPEKT_DEADLINE:{
  console.log("ON_ERROR_UPDATE_PROSPEKT_DEADLINE",action)
  return {
    ...state,
    ResponseAvtalMsg:{msg:translate("Error.update.deadline.prospekt"),type:"error",loading:false},
  }
}
//ProspektListByUser
    default:
        return state;
    }
}
